// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"68ae149a","179":"d01dcd6d","207":"1eb4e915","330":"5a846bf0","594":"0e6c8d2e"}[chunkId] + ".js";
};